import gql from 'graphql-tag';

const findAllUsers = gql`
query($limit:Int,$skip:Int){
  findUserMany(limit:$limit, skip:$skip){
    _id,
    firstName,
    lastName,
    email,
    emailVerified,
    isDeleted,
    balanceInPennies,
    createdAt,
    updatedAt
  }
}
`;

export interface findAllUsersResponse {
  findUserMany: Array<{
    _id: string;
    firstName?: string;
    lastName?: string;
    email: string;
    emailVerified?: boolean;
    isDeleted?: boolean;
    balanceInPennies?: number;
    createdAt: string;
    updatedAt: string;
  }>;
}
export interface findAllUsersVariable {
  limit?: number;
  skip?: number;
}

export default findAllUsers;
